module.exports = __webpack_public_path__ + "img/ic_mlg_coupon1.195d8adc.svg";